import styled from 'styled-components';

export const StyledFullPageListFilters = styled.div`
  display: block;
  justify-content: space-between;
  color: var(--limedSpruce);
`
